import { CanvasNode } from "../models/CanvasNode.ts";
import SidePanel from "../models/types";
import { useFlowStore } from "../store/FlowStateStore.ts";

const addComponent = (data: SidePanel, nodes: CanvasNode[], setNodes: any, position?: { x: number; y: number }) => {

  if (!data.enabled)
    return;
  const node: CanvasNode = new CanvasNode(data);

  if (position) {
    // Exact drop location (connection dragged to empty canvas) — no jitter.
    node.position = position;
  } else {
    // Sidebar click — center of the user's current viewport, with a small
    // random offset so repeated clicks don't stack nodes exactly on top of each other.
    const center = useFlowStore.getState().getViewportCenter?.();
    if (center) {
      node.position = {
        x: center.x + (Math.random() * 80 - 40),
        y: center.y + (Math.random() * 80 - 40),
      };
    }
  }

  setNodes([...nodes, node]);
}

export default addComponent;
